import _toConsumableArray from "/Users/wuliang/WorkSpace.localized/courses/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import LinesAndColumns from "lines-and-columns";
import { formatTokenType } from "../parser/tokenizer/types";
export default function formatTokens(code, tokens) {
  if (tokens.length === 0) {
    return "";
  }

  var tokenKeys = Object.keys(tokens[0]).filter(function (k) {
    return k !== "type" && k !== "value" && k !== "start" && k !== "end" && k !== "loc";
  });
  var typeKeys = Object.keys(tokens[0].type).filter(function (k) {
    return k !== "label" && k !== "keyword";
  });
  var headings = ["Location", "Label", "Raw"].concat(_toConsumableArray(tokenKeys), _toConsumableArray(typeKeys));
  var lines = new LinesAndColumns(code);
  var rows = [headings].concat(_toConsumableArray(tokens.map(getTokenComponents)));
  var padding = headings.map(function () {
    return 0;
  });

  var _iterator = _createForOfIteratorHelper(rows),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var components = _step.value;

      for (var i = 0; i < components.length; i++) {
        padding[i] = Math.max(padding[i], components[i].length);
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return rows.map(function (components) {
    return components.map(function (component, i) {
      return component.padEnd(padding[i]);
    }).join(" ");
  }).join("\n");

  function getTokenComponents(token) {
    var raw = code.slice(token.start, token.end);
    return [formatRange(token.start, token.end), formatTokenType(token.type), truncate(String(raw), 14)].concat(_toConsumableArray(tokenKeys.map(function (key) {
      return formatValue(token[key], key);
    })), _toConsumableArray(typeKeys.map(function (key) {
      return formatValue(token.type[key], key);
    })));
  } // eslint-disable-next-line @typescript-eslint/no-explicit-any


  function formatValue(value, key) {
    if (value === true) {
      return key;
    } else if (value === false || value === null) {
      return "";
    } else {
      return String(value);
    }
  }

  function formatRange(start, end) {
    return "".concat(formatPos(start), "-").concat(formatPos(end));
  }

  function formatPos(pos) {
    var location = lines.locationForIndex(pos);

    if (!location) {
      return "Unknown";
    } else {
      return "".concat(location.line + 1, ":").concat(location.column + 1);
    }
  }
}

function truncate(s, length) {
  if (s.length > length) {
    return "".concat(s.slice(0, length - 3), "...");
  } else {
    return s;
  }
}